export const FluideContainer = ({ children }) => (
  <div className="fluide-container">{children}</div>
);
